import { render, staticRenderFns } from "./PaymentErrorLogs.vue?vue&type=template&id=45818ce6"
import script from "./PaymentErrorLogs.vue?vue&type=script&lang=js"
export * from "./PaymentErrorLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports